import EXIF from 'gyl-common/utils/exif'

export default EXIF
